import { DomainIcon } from "components/icon";
import FormInput from "../UI/FormInput";
import i18n from "i18n";

const DomainInput = ({
  label = i18n.t("form:domain"),
  placeholder = "company.com",
  id = null,
  required = true,
  helperText = i18n.t("form:domainHelper"),
}) => {
  return (
    <FormInput
      startAdornment={<DomainIcon sx={{ width: 15 }} />}
      label={label}
      placeholder={placeholder}
      type="text"
      id={id}
      autoComplete={id}
      required={required}
      helperText={helperText}
      showHelperWithError={false}
      errorMsg={[
        {
          errorMsg: helperText,
          validation: "required",
        },
        {
          errorMsg: i18n.t("form:domainInvalid"),
          validation: "pattern",
        },
        {
          errorMsg: i18n.t("form:domainAlreadyAdded"),
          validation: "already_exist",
        },
      ]}
    />
  );
};

export default DomainInput;
